"use client";
import React, { useEffect, useState } from "react";
import { Spin, Pagination } from "antd";
import bookAPI from "@/services/book_api";
import { slugToOrderBy } from "@/utils/stripHtml";
import { IDetailStory, ResponseTypes } from "@/types/constants";
import CardBook from "@/components/card-book";
import Nodata from "@/components/no-data";
import { definitions } from "@/services/metruyenvl";
import { ReadonlyURLSearchParams, useRouter, useSearchParams } from "next/navigation";

function ListTabRank({ title }: any) {
    const BOOKS_LIMIT = 20;

    const [listBooks, setListBooks] = useState<definitions["do.BookDO"][]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [total, setTotal] = useState<number>(1);
    // const [pageSize, setPageSize] = useState<number>(20);
    const [count, setCount] = useState<number>(0);
    const searchParams: ReadonlyURLSearchParams = useSearchParams();
    const router = useRouter();

    useEffect(() => {
        setLoading(true);
        // setPageSize(parseInt(searchParams.get("size") ?? "20"));
        const getListItem = async () => {
            try {
                const res: ResponseTypes = await bookAPI.getAll({ orderBy: slugToOrderBy(title), page: parseInt(searchParams.get("page") ?? "1"), pageSize: parseInt(searchParams.get("size") ?? "" + BOOKS_LIMIT) });
                setListBooks(res.data);
                setTotal(res.paging?.total as number);
            } catch (error) {
                console.log(error);
            }
            setLoading(false);
        };
        getListItem();
        // console.log(count + 1);
        // setCount(1 + count);
        // console.log(count)
    }, [searchParams]);

    const onchangePage = (e: any, size: number) => {
        router.push(`${window.location.pathname}?page=${e}&size=${size}`);
    };
    return (
        <Spin spinning={loading} delay={500}>
            <div className="w-full flex flex-col gap-6">
                <div className="w-full gap-x-4 md:grid grid-cols-2">
                    <CardBook books={listBooks} booksSizeExpected={BOOKS_LIMIT} />
                </div>
                {total === 0 && <Nodata />}
                {total > 0 && (
                    <div className="flex justify-end">
                        <Pagination current={parseInt(searchParams.get("page") ?? "1")} pageSize={parseInt(searchParams.get("size") ?? "20")} onChange={onchangePage} total={total} />
                    </div>
                )}
            </div>
        </Spin>
    );
}

export default ListTabRank;
